module.exports = __webpack_public_path__ + "images/panorama-360-3-96b51210d5215f4c12889fbca2c1b557.jpg";